import { render, staticRenderFns } from "./singleSessionData.vue?vue&type=template&id=7ad89435&scoped=true"
import script from "./singleSessionData.vue?vue&type=script&lang=js"
export * from "./singleSessionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad89435",
  null
  
)

export default component.exports